import {
  IGNORE_RENT_AMOUNT_CHANGE,
  REQUEST_CREATE_PAYMENT_METHOD,
  REQUEST_ENROLL_RENTER_IN_CREDIT_TRACKING,
  REQUEST_GET_FEATURE_PERMISSIONS,
  REQUEST_PAYMENT_REPORTING_HISTORY,
  REQUEST_PAYMENT_REPORTING_OPT_IN,
  REQUEST_PAYMENT_REPORTING_OPT_OUT,
  REQUEST_PAYMENT_REPORTING_STATUS,
  REQUEST_PAYMENT_REPORTING_STATUS_WITH_CREDIT_TRACKING,
  REQUEST_RENTER_STATUS,
  SHOW_RENT_AMOUNT_CHANGE,
  UPDATE_ARRAY_USER_TOKEN,
  UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS,
} from '@renter-hub/constants/actionTypes';
import RenterStatusModel from '@renter-hub/models/RenterStatus';
import requestStatus from '@common/constants/requestStatus';

const initState = {
  ...RenterStatusModel(),
  ignoreRentAmountChange: false,
  requestStatus: null,
  httpStatus: null,
};

const dashboardReducer = (state = initState, action: any = {}) => {
  switch (action.type) {
    case REQUEST_RENTER_STATUS.INIT:
      return {
        ...state,
        requestStatus: requestStatus.INIT,
        httpStatus: null,
      };
    case REQUEST_RENTER_STATUS.SUCCESS: {
      return {
        ...state,
        ...action.payload.renterStatus,
        httpStatus: action.payload.httpStatus,
        requestStatus: requestStatus.SUCCESS,
      };
    }
    case REQUEST_RENTER_STATUS.FAIL:
      return {
        ...state,
        requestStatus: requestStatus.FAIL,
        httpStatus: action.payload.httpStatus,
      };
    case REQUEST_PAYMENT_REPORTING_STATUS.SUCCESS: {
      return {
        ...state,
        paymentReporting: action.payload,
        requestStatus: requestStatus.SUCCESS,
      };
    }
    case REQUEST_PAYMENT_REPORTING_STATUS_WITH_CREDIT_TRACKING.SUCCESS: {
      return {
        ...state,
        requestStatus: requestStatus.SUCCESS,
        paymentReporting: {
          ...state.paymentReporting,
          optedIn: action.payload.optedIn,
          optInDate: action.payload.optInDate,
          creditTracking: {
            ...action.payload.creditTracking,
            lastFetchedTimestamp: Date.now(),
          },
        },
      };
    }
    case REQUEST_PAYMENT_REPORTING_HISTORY.SUCCESS: {
      return {
        ...state,
        paymentReportHistory: action.payload,
        requestStatus: requestStatus.SUCCESS,
      };
    }
    case REQUEST_PAYMENT_REPORTING_OPT_IN.SUCCESS: {
      return {
        ...state,
        paymentReporting: action.payload,
        requestStatus: requestStatus.SUCCESS,
      };
    }
    case REQUEST_PAYMENT_REPORTING_OPT_OUT.SUCCESS: {
      return {
        ...state,
        paymentReporting: { optedIn: false },
        requestStatus: requestStatus.SUCCESS,
      };
    }
    case IGNORE_RENT_AMOUNT_CHANGE:
      return {
        ...state,
        ignoreRentAmountChange: true,
      };
    case SHOW_RENT_AMOUNT_CHANGE:
      return {
        ...state,
        ignoreRentAmountChange: false,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.INIT:
      return {
        ...state,
        requestStatus: requestStatus.INIT,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        requestStatus: requestStatus.SUCCESS,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.FAIL:
      return {
        ...state,
        requestStatus: requestStatus.FAIL,
      };
    case REQUEST_CREATE_PAYMENT_METHOD.SUCCESS:
      return {
        ...state,
        selectedPaymentMethod: action.payload.paymentMethod,
      };
    case REQUEST_ENROLL_RENTER_IN_CREDIT_TRACKING.SUCCESS:
      return {
        ...state,
        requestStatus: requestStatus.SUCCESS,
      };
    case REQUEST_ENROLL_RENTER_IN_CREDIT_TRACKING.FAIL:
      return {
        ...state,
        requestStatus: requestStatus.FAIL,
      };
    case UPDATE_ARRAY_USER_TOKEN:
      return {
        ...state,
        paymentReporting: {
          ...state.paymentReporting,
          creditTracking: {
            ...state.paymentReporting?.creditTracking,
            arrayUserToken: action.payload.arrayUserToken,
          },
        },
      };
    case UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS:
      return {
        ...state,
        paymentReporting: {
          ...state.paymentReporting,
          creditTracking: {
            ...state.paymentReporting?.creditTracking,
            enrollmentStatus: action.payload.enrollmentStatus,
          },
        },
      };
    default:
      return state;
  }
};

export default dashboardReducer;
